import { render, staticRenderFns } from "./Step1ChoosePage.vue?vue&type=template&id=03df5e3a&"
import script from "./Step1ChoosePage.vue?vue&type=script&lang=js&"
export * from "./Step1ChoosePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Step1ChoosePage.vue"
export default component.exports